import type { FaireProductEntity } from "../../entity_types/product";

export const p_68xz54736c: FaireProductEntity = {
  token: "p_68xz54736c",
  type: "product",
  name: "HELLO KITTY CHOPSTICKS BOWL 3PC SET, 13109",
  brandToken: "b_gk6kg6d4dw",
  brandName: "JOIA ACCESSORIES",
  imageUrl:
    "https://cdn.faire.com/fastly/ac3e05122e8c2865e52c0d42544adcff2ac1b96d98de68d6036aa06979dbfa90.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1795c67c3a1ef6771313f141cbdff040aa6e30f90be331f59a79012a703bd546.jpeg",
  ],
  priceDollars: 11.43,
  description:
    'HELLO KITTY CHOPSTICKS BOWL 3PC SET 6" CHOPSTICK BOWL 20 OZ. (591 ML.)',
  tags: [],
  msrpDollars: 22.52,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:22.257Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
